import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Heading, Spinner, Table, Text, VStack, SimpleGrid, Badge, Avatar, Separator } from '@chakra-ui/react';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { gql } from '@src/lib/gql';
import { ReactNode } from 'react';
import { LuBriefcase } from 'react-icons/lu';
export const UserMatchExpandedProfile = props => {
  const $ = _c(97);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($userMatchId: String!) {
        scoUserMatch(userMatchId: $userMatchId) {
          id
          targetUser {
            id
            userId
            firstName
            bio
            shortBio
            linkedin
            lastActiveAt
            userSkills(order: [["experienceStrength", "desc"]]) {
              id
              userSkillId
              title
              description
              experienceNotes
              experienceStrength
            }
            userExperiences {
              id
              userExperienceId
              experienceTypeKey
              accomplishmentDescription
              accomplishmentTypeKeys
              createdAt
              endDate
              industryKeys
              organizationName
              positionTitle
              positionDescription
              startDate
            }
            company {
              id
              companyId
              elevatorPitch
              fundingRaisedKey
              logoUrl
              name
              url
              annualRevenue {
                id
                title
              }
              fundingRaised {
                id
                title
              }
              fundingStage {
                id
                title
              }
              headcount {
                id
                title
              }
              industries {
                id
                title
              }
              stage {
                id
                title
              }
              yearFounded
            }
          }
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.userMatchId) {
    t1 = {
      variables: {
        userMatchId: props.userMatchId
      }
    };
    $[1] = props.userMatchId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  const user = query.data?.scoUserMatch?.targetUser;
  if (!user) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center padding="1em"><Spinner /></Center>;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== getBreakpointValue) {
    t2 = getBreakpointValue(["4", "4", "8", "8"]);
    $[4] = getBreakpointValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== getBreakpointValue) {
    t3 = getBreakpointValue(["2", "2", "6", "6"]);
    $[6] = getBreakpointValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `About ${user.firstName}`;
  let t5;
  if ($[8] !== user.bio) {
    t5 = user.bio && <ProfileItem title="Bio"><MarkdownRenderer preset="ugc">{user.bio}</MarkdownRenderer></ProfileItem>;
    $[8] = user.bio;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [1, 1, 2];
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== user.title) {
    t7 = user.title && <ProfileItem text={user.title} title="Title" />;
    $[11] = user.title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== user.shortBio) {
    t8 = user.shortBio && <ProfileItem text={user.shortBio} title="Short Bio" />;
    $[13] = user.shortBio;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== user.location) {
    t9 = user.location && <ProfileItem text={user.location} title="Location" />;
    $[15] = user.location;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== user.linkedin) {
    t10 = user.linkedin && <ProfileItem title="LinkedIn"><MarkdownRenderer preset="ugc">{user.linkedin}</MarkdownRenderer></ProfileItem>;
    $[17] = user.linkedin;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== user.twitter) {
    t11 = user.twitter && <ProfileItem title="X/Twitter"><MarkdownRenderer preset="ugc">{user.twitter}</MarkdownRenderer></ProfileItem>;
    $[19] = user.twitter;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t12 = <SimpleGrid columns={t6} gap={4}>{t7}{t8}{t9}{t10}{t11}</SimpleGrid>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t5) {
    t13 = <SimpleGrid columns={1} gap={4}>{t5}{t12}</SimpleGrid>;
    $[27] = t12;
    $[28] = t5;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t4) {
    t14 = <ProfileSection title={t4}>{t13}</ProfileSection>;
    $[30] = t13;
    $[31] = t4;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Separator borderColor="colorPalette.border" />;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [1, 1, 2];
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== user.company.name) {
    t17 = user.company.name && <ProfileItem text={user.company.name} title="Name" />;
    $[35] = user.company.name;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== user.company.logoUrl) {
    t18 = user.company.logoUrl && <ProfileItem title="Logo"><Avatar.Root bgColor="colorPalette.fg" borderRadius="md" color="primary"><Avatar.Fallback borderRadius="md"><LuBriefcase /></Avatar.Fallback><Avatar.Image borderRadius="md" src={user.company.logoUrl} /></Avatar.Root></ProfileItem>;
    $[37] = user.company.logoUrl;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t17 || $[40] !== t18) {
    t19 = <SimpleGrid columns={t16} gap={4}>{t17}{t18}</SimpleGrid>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== user.company.elevatorPitch) {
    t20 = user.company.elevatorPitch && <ProfileItem title="Elevator Pitch"><MarkdownRenderer preset="ugc">{user.company.elevatorPitch}</MarkdownRenderer></ProfileItem>;
    $[42] = user.company.elevatorPitch;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = [1, 1, 2, 4];
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== user.company.industries) {
    t22 = user.company.industries && <ProfileItem text={user.company.industries?.map(_temp).join(", ")} title="Industry" />;
    $[45] = user.company.industries;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== user.company.location) {
    t23 = user.company.location && <ProfileItem text={user.company.location} title="Location" />;
    $[47] = user.company.location;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== user.company.url) {
    t24 = user.company.url && <ProfileItem title="Website"><MarkdownRenderer preset="ugc">{user.company.url}</MarkdownRenderer></ProfileItem>;
    $[49] = user.company.url;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== user.company.headcount) {
    t25 = user.company.headcount && <ProfileItem text={user.company.headcount?.title} title="Team Size" />;
    $[51] = user.company.headcount;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== user.company.stage) {
    t26 = user.company.stage && <ProfileItem text={user.company.stage?.title} title="Company Stage" />;
    $[53] = user.company.stage;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== user.company.fundingStage) {
    t27 = user.company.fundingStage && <ProfileItem text={user.company.fundingStage?.title} title="Funding Stage" />;
    $[55] = user.company.fundingStage;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== user.company.fundingRaised) {
    t28 = user.company.fundingRaised && <ProfileItem text={user.company.fundingRaised?.title} title="Funding Raised" />;
    $[57] = user.company.fundingRaised;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== user.company.annualRevenue) {
    t29 = user.company.annualRevenue && <ProfileItem text={user.company.annualRevenue?.title} title="Annual Revenue" />;
    $[59] = user.company.annualRevenue;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== t22 || $[62] !== t23 || $[63] !== t24 || $[64] !== t25 || $[65] !== t26 || $[66] !== t27 || $[67] !== t28 || $[68] !== t29) {
    t30 = <SimpleGrid columns={t21} gap={4}>{t22}{t23}{t24}{t25}{t26}{t27}{t28}{t29}</SimpleGrid>;
    $[61] = t22;
    $[62] = t23;
    $[63] = t24;
    $[64] = t25;
    $[65] = t26;
    $[66] = t27;
    $[67] = t28;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t19 || $[71] !== t20 || $[72] !== t30) {
    t31 = <ProfileSection title="Company"><SimpleGrid columns={1} gap={4}>{t19}{t20}{t30}</SimpleGrid></ProfileSection>;
    $[70] = t19;
    $[71] = t20;
    $[72] = t30;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Separator borderColor="colorPalette.border" />;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== getBreakpointValue) {
    t33 = getBreakpointValue(["nowrap", "nowrap", "normal"]);
    $[75] = getBreakpointValue;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  let t34;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Table.Header><Table.Row><Table.ColumnHeader>Skill</Table.ColumnHeader><Table.ColumnHeader>Strength</Table.ColumnHeader><Table.ColumnHeader>Explanation</Table.ColumnHeader></Table.Row></Table.Header>;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== user.userSkills) {
    t35 = user.userSkills.map(_temp2);
    $[78] = user.userSkills;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== t35) {
    t36 = <Table.Root>{t34}<Table.Body>{t35}</Table.Body></Table.Root>;
    $[80] = t35;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== t33 || $[83] !== t36) {
    t37 = <ProfileSection title="Skills"><Table.ScrollArea borderRadius="md" whiteSpace={t33}>{t36}</Table.ScrollArea></ProfileSection>;
    $[82] = t33;
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Separator borderColor="colorPalette.border" />;
    $[85] = t38;
  } else {
    t38 = $[85];
  }
  let t39;
  if ($[86] !== user.userExperiences) {
    t39 = user.userExperiences.map(_temp3);
    $[86] = user.userExperiences;
    $[87] = t39;
  } else {
    t39 = $[87];
  }
  let t40;
  if ($[88] !== t39) {
    t40 = <ProfileSection title="Experiences"><SimpleGrid columns={1} gap={10} mt={4}>{t39}</SimpleGrid></ProfileSection>;
    $[88] = t39;
    $[89] = t40;
  } else {
    t40 = $[89];
  }
  let t41;
  if ($[90] !== t14 || $[91] !== t2 || $[92] !== t3 || $[93] !== t31 || $[94] !== t37 || $[95] !== t40) {
    t41 = <VStack align="stretch" gap={t2} padding={t3}>{t14}{t15}{t31}{t32}{t37}{t38}{t40}</VStack>;
    $[90] = t14;
    $[91] = t2;
    $[92] = t3;
    $[93] = t31;
    $[94] = t37;
    $[95] = t40;
    $[96] = t41;
  } else {
    t41 = $[96];
  }
  return t41;
};
const ProfileSection = props => {
  const $ = _c(6);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue || $[1] !== props.title) {
    t0 = props.title && <Heading paddingBottom={4} size={getBreakpointValue(["md", "md", "lg", "xl"])}>{props.title}</Heading>;
    $[0] = getBreakpointValue;
    $[1] = props.title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.children || $[4] !== t0) {
    t1 = <Box borderRadius="md">{t0}{props.children}</Box>;
    $[3] = props.children;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const ProfileItem = props => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.title) {
    t0 = props.title && <Text color="colorPalette.fg/50" textStyle="badgeSm">{props.title}</Text>;
    $[0] = props.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.text) {
    t1 = props.text && <Text>{props.text}</Text>;
    $[2] = props.text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = props.children || null;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = <VStack align="flex-start" bgColor="colorPalette.container" borderRadius="md" padding={4} width="full">{t0}{t1}{t2}</VStack>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function _temp(industry) {
  return industry.title;
}
function _temp2(userSkill) {
  return <Table.Row key={userSkill.id}><Table.Cell>{userSkill.title}</Table.Cell><Table.Cell>{userSkill.experienceStrength} / 100</Table.Cell><Table.Cell>{userSkill.experienceNotes}</Table.Cell></Table.Row>;
}
function _temp3(userExperience) {
  return <ProfileSection key={userExperience.id}><Heading paddingBottom={4} size="lg"><Badge colorPalette="purple" marginRight={2}>{userExperience.experienceTypeKey?.toUpperCase() || "EXPERIENCE"}</Badge>{userExperience.organizationName}</Heading><SimpleGrid borderColor="colorPalette.border" borderLeft="2px solid" columns={1} gap={4} paddingLeft={5}><ProfileItem text={userExperience.positionTitle} title="Title" /><ProfileItem text={userExperience.positionDescription} title="Position Description" /><ProfileItem text={userExperience.accomplishmentDescription} title="Accomplishment Notes" /></SimpleGrid></ProfileSection>;
}